import { DataResponseTransformed, TabletReactQueryState } from "./tabletReactQuery";

export interface ServiceType {
  id: number;
  key: string;
  name: string;
  description: string;
  number: number;
}

export interface ServiceTypesModel extends DataResponseTransformed {
  rows: ServiceType[];
}


export interface ServiceTypesState extends TabletReactQueryState {
  filters?: any;
  columnVisibility?: any
}



export const serviceTypesBuilder = {
  fromBackEnd: (serviceType: any): ServiceType => ({
    id: serviceType.id,
    key: serviceType.key,
    name: serviceType.name,
    description: serviceType.description,
    number: serviceType.number
  })
}